module.exports = __webpack_public_path__ + "static/media/load-unpacked.b88c4bb0.gif";